import React from 'react'
import { itemQuantity } from '../../../../shared/item-count.js'

// The amber ×N badge that marks a line of several units. Receiving, Testing
// and Photography all show it, so a unit count looks the same on every screen.
// A quantity of 1, or a missing one, shows nothing.
const BADGE_STYLE = {
  display: 'inline-flex',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  padding: '4px 10px',
  borderRadius: '20px',
  fontSize: '12px',
  fontWeight: 600,
  background: '#FFF9E6',
  color: '#B8860B'
}

export default function QuantityBadge({ quantity }) {
  const units = itemQuantity({ quantity })
  if (units <= 1) return null
  return <span style={BADGE_STYLE}>×{units}</span>
}
